import type { ComponentType } from 'react';
import { useProperty, ValidationProvider } from '@eti/providers';
import validationRules from '../utils/validationRules';
import type { ValidationTexts } from '../hooks/useValidationTexts';

interface withValidationProviderProps {
  validationTexts: ValidationTexts;
}

export const withValidationProvider = (WrappedComponent: ComponentType<any>) => {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'component';

  const ComponentWithValidationProvider = ({
    validationTexts,
    ...props
  }: withValidationProviderProps) => {
    const { p } = useProperty();
    const taxIdFieldLabel = p('Payment.TaxIdFeature.Label');
    const taxIdFieldFormat = p('Payment.TaxIdFeature.Format');
    const isTaxIdRequired = p('Payment.TaxIdFeature.isRequired');
    const allowedCharacters = p('IbeClient.FormValidation.AllowedCharactersInTravelerNames');
    const validationDisabledCards = p('Payment.DeactivateLuhnCheckForCards')?.split(',');
    return (
      <ValidationProvider
        rules={validationRules(
          isTaxIdRequired,
          validationTexts,
          taxIdFieldLabel,
          taxIdFieldFormat,
          allowedCharacters,
          validationDisabledCards,
        )}
      >
        <WrappedComponent taxIdLabel={taxIdFieldLabel} {...props} />
      </ValidationProvider>
    );
  };

  ComponentWithValidationProvider.displayName = `withValidationProvider(${displayName})`;

  return ComponentWithValidationProvider;
};
